import AttendanceList from './list.vue';
let a = Object.assign({ AttendanceList });
export default a;